export default __webpack_public_path__ + "7816aa3c687ddef3ee5880c38aede21a.png";